<template>
  <div class="layout--text-button-wrap" :class="'credit-card__wrap ' + classes">
    <p
      v-if="defaultCard"
      class="text-size-md-sm layout--flex-align-center layout--margin-bottom-sm"
    >
      <font-awesome-icon
        v-if="creditCardIcon"
        :icon="['fab', creditCardIcon]"
        class="text-size-lg-md layout--margin-right-xs"
      />
      {{ defaultCard.cardType }} ending in
      <strong class="layout--margin-left-xs layout--margin-right-md">{{
        defaultCard.lastFour
      }}</strong>
    </p>
    <button
      type="button"
      class="button layout--margin-bottom-sm"
      :class="{ 'button--secondary': secondary }"
      v-on:click="updateCreditCardModal"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { getCreditCardIcon } from "../helpers/helpers";

import UpdateCardModal from "./UpdateCardModal";

export default {
  name: "creditCard",
  props: {
    buttonText: {
      type: String,
      default: "Edit Card Information",
    },
    classes: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    isAddCard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("account", ["defaultCard", "account"]),
    creditCardIcon: function() {
      if (this.defaultCard && this.defaultCard.cardType) {
        return getCreditCardIcon(this.defaultCard.cardType);
      }
      return null;
    },
  },
  methods: {
    updateCreditCardModal: function() {
      const isSuspended = this.account.suspended;
      const isAccountPage = this.$route.name === 'plan and billing';

      this.$modal.show(UpdateCardModal, {
        suspendedMessage: isSuspended && isAccountPage 
      });
    },
  },
};
</script>

<style></style>
